
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

export default {
    tooltip : {
        formatter: "{a} <br/>{b} : {c}%"
    },
    toolbox: {
        feature: {
            restore: {},
            saveAsImage: {}
        }
    },
    series: [
        {
            name: getLabel(387998,"业务指标"),
            type: 'gauge',
            detail: {formatter:'{value}%'},
            data: [{value: 50, name: getLabel(30447,"完成率")}]
        }
    ]
};


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/echart/examples/gauge.js